import axios from 'axios';

const api = axios.create({
  baseURL: 'http://localhost:5005',
});

async function capturaDigitalIniciar() {
  const response = await api.post('/api/biometria/captura/iniciar');
  return response.data;
}

async function capturaDigitalConfirmar() {
  const response = await api.post('/api/biometria/captura/confirmar');
  return response.data;
}

async function identificarBiometria(cancelToken) {
  const response = await api.post(
    '/api/biometria/identificar',
    {},
    { timeout: 20000, cancelToken },
  );
  return response.data;
}

export {
  capturaDigitalIniciar,
  capturaDigitalConfirmar,
  identificarBiometria,
};
